var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-box"},[_c('van-image',{staticClass:"bg-box",attrs:{"src":_vm.mainImage}}),_c('div',{staticClass:"logo-footer"},[_c('van-image',{attrs:{"fit":"contain","src":_vm.logoImage}})],1),_c('van-loading',{attrs:{"type":"spinner","size":"40px","color":"#ffffff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }